import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularModule } from 'shared/modules/angular/angular.module';
import {
  ItemsSearchWrapperComponent,
} from 'shared/modules/items-search-wrapper/items-search-wrapper.component';
import { MaterialModule } from 'shared/modules/material/material.module';
import { SearchOptionComponent } from './search-option/search-option.component';

@NgModule({
  declarations: [
    ItemsSearchWrapperComponent,
    SearchOptionComponent,
  ],
  exports: [
    ItemsSearchWrapperComponent,
    SearchOptionComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    AngularModule,
    MaterialModule,
  ],
})
export class ItemsSearchWrapperModule {}
